import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCustomUrl, getPage, getPartner, getUser } from '../../../../utils/tracking';
import { getProducts } from '../../../../utils/tracking/get_products';

const baseEvent = {
  name: 'oldevent',
};

export function trackShowPhones(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  user: IUserSchema | null,
  abGroup: number,
  kpId: number | null,
) {
  const products = getProducts(agent, offer, kpId);

  ca(
    'eventSite',
    Object.assign(
      {
        action: 'Open_card_fullscreen_gallery',
        category: 'Phones',
        label: getCustomUrl(offer, agent),
        page: getPage(agent, offer),
        partner: getPartner(user, offer),
        products: [
          {
            ...products,
            variant: products.variant ? products.variant.split('/') : [],
          },
        ],
        user: getUser(user, abGroup),
      },
      baseEvent,
    ),
  );
}

/* istanbul ignore next */
export function trackClickFavorite(offer: IOfferSchema, agent: IAgentSchema | null) {
  ca(
    'event',
    Object.assign(
      {
        action: 'add_from_card_fullscreen_gallery',
        category: 'favorite',
        label: getCustomUrl(offer, agent),
      },
      baseEvent,
    ),
  );
}
